import { createAsyncType } from '@/store/utils/mutation-types'

export default {
    RESET: 'RESET',
    GET_ITEM: createAsyncType('GET_ITEM'),
    UPDATE_ITEM: createAsyncType('UPDATE_ITEM'),
    CREATE_ITEM: createAsyncType('CREATE_ITEM'),
    REMOVE_ITEM: createAsyncType('REMOVE_ITEM'),
    GET_USER: createAsyncType('GET_USER'),
    GET_TEAM: createAsyncType('GET_TEAM'),
    SET_COMPLETED: createAsyncType('SET_COMPLETED')
}
